import React from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import OutputIcon from '@mui/icons-material/Output';
import Typography from '@mui/material/Typography';
import SubjectIcon from '@mui/icons-material/Subject';

import { getAPI } from '../util/APIUtils';

import { ViewerState } from '../states/viewerState';
import { AppState } from '../states/appState';
import { MainMenuActions } from '../containers/mainMenuContaner';
import { DocumentCreateDialog } from './DocumentCreateDialog';

type Props = {} & ViewerState & MainMenuActions & AppState;

export interface DownloadDocument {
  allact?: string;
  revision?: string;
  newold?: string;
}
const initialDownloadDocument = () => {
  return {};
};

export const MainMenu: React.FC<Props> = (props) => {

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // 資料作成
  const [anchorElDocumentCreateDialog, setAnchorElDocumentCreateDialog] = React.useState(false);
  const openAnchorElDocumentCreateDialog = Boolean(anchorElDocumentCreateDialog);
  const handleCloseAnchorElDocumentCreateDialog = () => {
    setAnchorElDocumentCreateDialog(false);
    setDownloadDocument(initialDownloadDocument());
  }

  const [downloadDocument, setDownloadDocument] = React.useState<DownloadDocument>(initialDownloadDocument());

  const handleAnchorElDocumentCreateDialog = async (type: number) => {
    setAnchorElDocumentCreateDialog(false);
    props.setLoading(true);

    const url = props.type === 'editing'
      ? `/acts/${props.actId}/editings/${props.editingId}/steps/${props.stepId}/document?idid=${props.idid}&accountid=${props.accountid}&documentType=${type}`
      : `/acts/${props.actId}/${props.revision}/document?idid=${props.idid}&accountid=${props.accountid}&documentType=${type}`;
    try {
      const json = await getAPI(url);
      const tmp: string = json.outPath;
      const newOutPath = tmp.replace(/private\/.*?\//, '');
      switch (type) {
        case 0:
        case 5:
          downloadDocument.allact = newOutPath;
          break;
        default:
          break;
      }
    } catch (e) {
      // TODO エラー
      console.log(e);
    }
    setAnchorElDocumentCreateDialog(true);
    props.setLoading(false);
  };

  const viewDocumentCreate = () => {
    handleClose();
    setAnchorElDocumentCreateDialog(true);
  };

  // 精査メニュー選択
  // const handleSelect = (type) => {
  //   props.setLoading(true);
  //   handleClose();
  //   props.setPosNextPrev(-1);
  //   window.scrollTo({
  //     left: 0,
  //     top: 0,
  //     behavior: 'smooth'
  //   });
  //   props.initExaminationViewerAsync(props.actId, props.editingId, props.stepId, type, false);
  // };

  const changeStep = (stepId: number) => {
    // 一部改正のみのためEditTypeは1固定
    const query = `?type=${'editor'}&actId=${props.actId}&editingId=${props.editingId}&stepId=${stepId}&editType=${'1'}&miekesi=true`;
    const url = process.env.REACT_APP_VIEWER_URL ? process.env.REACT_APP_VIEWER_URL.replace('{hostname}', window.location.hostname) : process.env.REACT_APP_VIEWER_URL;
    window.location.href = url + query;
  };
  const changeStepExamination = (stepId: number) => {
    const query = `?type=${'examination'}&actId=${props.actId}&editingId=${props.editingId}&stepId=${stepId}&miekesi=true`;
    const url = process.env.REACT_APP_VIEWER_URL ? process.env.REACT_APP_VIEWER_URL.replace('{hostname}', window.location.hostname) : process.env.REACT_APP_VIEWER_URL;
    window.location.href = url + query;
  };

  const createMenuItems = () => {
    if (props.type === 'examination') {
      if (props.maxStepId > 1) {
        const arr = [...Array(props.maxStepId + 1)].map((_, i) => {
          if (i === 0) {
            return (
              <MenuItem key={i}>
                <Typography variant="inherit">表示中の段を変更する</Typography>
              </MenuItem>
            );
          } else if (props.stepId === '' + i) {
            return (
              <MenuItem key={i} sx={{ marginLeft: 2 }} disabled>
                <ListItemIcon>
                  <SubjectIcon fontSize="small" color='primary' />
                </ListItemIcon>
                <Typography variant="inherit">{i}段目</Typography>
              </MenuItem>
            );
          }
          return (
            <MenuItem key={i} sx={{ marginLeft: 2 }} onClick={() => changeStepExamination(i)}>
              <ListItemIcon>
                <SubjectIcon fontSize="small" color='primary' />
              </ListItemIcon>
              <Typography variant="inherit">{i}段目</Typography>
            </MenuItem>
          );
        });
        return (
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            {arr}
          </Menu>
        );
      }
      return '';
      // return (
      //   <Menu
      //     id="simple-menu"
      //     anchorEl={anchorEl}
      //     open={open}
      //     onClose={handleClose}
      //   >
      //     <MenuItem onClick={() => handleSelect(2)}>
      //       <ListItemIcon>
      //         <RadioButtonUncheckedIcon fontSize="small" color='primary' />
      //       </ListItemIcon>
      //       <Typography variant="inherit">用字用語精査</Typography>
      //     </MenuItem>
      //     <MenuItem onClick={() => handleSelect(3)}>
      //       <ListItemIcon>
      //         <RadioButtonUncheckedIcon fontSize="small" color='primary' />
      //       </ListItemIcon>
      //       <Typography variant="inherit">誤字等精査</Typography>
      //     </MenuItem>
      //     <MenuItem onClick={() => handleSelect(4)}>
      //       <ListItemIcon>
      //         <RadioButtonUncheckedIcon fontSize="small" color='primary' />
      //       </ListItemIcon>
      //       <Typography variant="inherit">全半角色分け</Typography>
      //     </MenuItem>
      //     <MenuItem onClick={() => handleSelect(1)}>
      //       <ListItemIcon>
      //         <RadioButtonUncheckedIcon fontSize="small" color='primary' />
      //       </ListItemIcon>
      //       <Typography variant="inherit">条項ずれ関連</Typography>
      //     </MenuItem>
      //     <MenuItem onClick={() => handleSelect(5)}>
      //       <ListItemIcon>
      //         <RadioButtonUncheckedIcon fontSize="small" color='primary' />
      //       </ListItemIcon>
      //       <Typography variant="inherit">見やすく表示</Typography>
      //     </MenuItem>
      //   </Menu>
      // );
    } else if (props.type === 'editing') {
      if (props.maxStepId > 1) {
        const arr = [...Array(props.maxStepId + 1)].map((_, i) => {
          if (i === 0) {
            return (
              <MenuItem key={i}>
                <Typography variant="inherit">表示中の段を変更する</Typography>
              </MenuItem>
            );
          } else if (props.stepId === '' + i) {
            return (
              <MenuItem key={i} sx={{ marginLeft: 2 }} disabled>
                <ListItemIcon>
                  <SubjectIcon fontSize="small" color='primary' />
                </ListItemIcon>
                <Typography variant="inherit">{i}段目</Typography>
              </MenuItem>
            );
          }
          return (
            <MenuItem key={i} sx={{ marginLeft: 2 }} onClick={() => changeStep(i)}>
              <ListItemIcon>
                <SubjectIcon fontSize="small" color='primary' />
              </ListItemIcon>
              <Typography variant="inherit">{i}段目</Typography>
            </MenuItem>
          );
        });
        return (
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <MenuItem onClick={viewDocumentCreate}>
              <ListItemIcon>
                <OutputIcon fontSize="small" color='primary' />
              </ListItemIcon>
              <Typography variant="inherit">資料を出力する</Typography>
            </MenuItem>
            {arr}
          </Menu>
        );
      }
      return (
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={viewDocumentCreate}>
            <ListItemIcon>
              <OutputIcon fontSize="small" color='primary' />
            </ListItemIcon>
            <Typography variant="inherit">資料を出力する</Typography>
          </MenuItem>
        </Menu>
      );
    }
    return (
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={viewDocumentCreate}>
          <ListItemIcon>
            <OutputIcon fontSize="small" color='primary' />
          </ListItemIcon>
          <Typography variant="inherit">資料を出力する</Typography>
        </MenuItem>
      </Menu>
    );
  };

  return (
    <div>
      <IconButton
        aria-owns={anchorEl ? 'simple-menu' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{
          marginLeft: -1,
          marginRight: 2,
        }}
        color="inherit"
        aria-label="Open drawer">
        <MenuIcon />
      </IconButton>
      {createMenuItems()}
      <DocumentCreateDialog
        open={openAnchorElDocumentCreateDialog}
        idid={props.idid}
        // editActInfo={stateEditActInfo}
        downloadDocument={downloadDocument}
        handleClose={handleCloseAnchorElDocumentCreateDialog}
        handleCreate={handleAnchorElDocumentCreateDialog}
      />
    </div>
  );
}
